<template>
  <section class="homepageLoyalty container defaultSectionMargins">
    <FlarePicture v-if="data.image"
      :src="{
        1440: { src: data.image, width: 1440, height: 667, size: 'both', crop: 'fill' },
        768: { src: data.image, width: 750, height: 1300, size: 'both', crop: 'fill' },
      }"
      :alt="data.image.alt"
    />

    <div class="homepageLoyalty__Content">
      <div>
        <Flare v-if="data.logo" :srcset="data.logo" width="200" class="homepageLoyalty__HeaderLogo" :alt="data.logo" />
  
        <h2 v-text="data.title" />
      </div>

      <div class="homepageLoyalty__PictorgramsWrapper">
        <div>
          <div v-for="item in data.pictograms.items" class="homepageLoyalty__Pictogram">
            <Flare :srcset="item.image" width="100" height="100" crop="fill" size="both" :alt="item.image" />
            <p v-if="item.description" v-text="item.description" />
          </div>
        </div>

        <Button v-if="data.page?.sef" type="nuxt-link" :to="data.page.sef" medium>{{ data.cta_text }}</Button>
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_homepageLoyalty.scss');
</style>